// extracted by mini-css-extract-plugin
module.exports = {"NoData":"NoData_NoData__qNdQs","NoData__content":"NoData_NoData__content__3dKtX"};